import { FormHelperText, TextField, TextFieldProps } from "@mui/material";
import type { JSX } from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";

import { InputError } from "@/components/inputError";

export interface NumericInputWithErrorProps
  extends Omit<NumericFormatProps<TextFieldProps>, "customInput" | "size" | "color" | "sx"> {
  errorMsg?: string;
  optional?: boolean;
  numericFormatSx?: TextFieldProps["sx"];
}

export const NumericInputWithError = ({
  errorMsg,
  optional,
  numericFormatSx,
  ...numericFormatInputProps
}: NumericInputWithErrorProps): JSX.Element => {
  return (
    <>
      <NumericFormat
        customInput={TextField}
        error={Boolean(errorMsg)}
        sx={[
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          (theme) => ({
            "& .MuiInputBase-root.Mui-disabled": {
              backgroundColor: theme.palette.action.disabledBackground,
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: theme.palette.text.disabled,
            },
          }),
          ...(Array.isArray(numericFormatSx) ? numericFormatSx : numericFormatSx ? [numericFormatSx] : []),
        ]}
        {...numericFormatInputProps}
      />
      {optional && <FormHelperText color="info">Optional</FormHelperText>}
      {errorMsg && <InputError errorMsg={errorMsg} />}
    </>
  );
};
